export default function initPopup() {
  const popup = document.getElementById('mailing-popup');
  const closeBtn = document.getElementById('mailing-popup-close');
  const mailingContent = document.getElementById('mailing-content');
  const thankYouMessage = document.getElementById('thank-you-message');
  const form = document.getElementById('MailingListForm');

  if (!popup || !closeBtn) return;

  popup.style.display = 'none';

  const hasSubscribed = localStorage.getItem('mailingListSubscribed');
  const popupShownThisSession = sessionStorage.getItem('mailingPopupShown');

  // Show popup if not subscribed AND not already shown in this session
  if (!hasSubscribed && !popupShownThisSession) {
    setTimeout(() => {
      popup.style.display = 'flex';
      sessionStorage.setItem('mailingPopupShown', 'true');
    }, 1000);
  }

  // Close popup (won't show again this session)
  closeBtn.addEventListener('click', () => {
    popup.style.display = 'none';
    sessionStorage.setItem('mailingPopupShown', 'true');
  });

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.style.display = 'none';
      sessionStorage.setItem('mailingPopupShown', 'true');
    }
  });

  // Handle form submission
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const submitButton = form.querySelector('input[type="submit"]');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.value = 'Subscribing...';
      }

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.text())
        .then(() => {
          mailingContent.style.display = 'none';
          thankYouMessage.style.display = 'block';

          // Mark as subscribed so popup NEVER shows again
          localStorage.setItem('mailingListSubscribed', 'true');

          // Auto-close after 10s
          setTimeout(() => {
            popup.style.display = 'none';
            mailingContent.style.display = 'block';
            thankYouMessage.style.display = 'none';
            form.reset();
          }, 10000);
        })
        .catch(error => {
          console.error('Error:', error);
          alert('There was an error submitting the form. Please try again.');
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.value = 'Subscribe';
          }
        });
    });
  }
}

document.addEventListener("DOMContentLoaded", initPopup);
